export default __webpack_public_path__ + "static/media/call.8dfe2ab7.svg";